var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.params.value),function(value,name){return _c('span',{key:name},[_vm._v(" "+_vm._s(name)+": "+_vm._s(value)+" "+_vm._s("|")+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }